import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSyncedReload } from "@/hooks/useSyncedReload";

// Searchable list with debounced server-side search.
// Encapsulates load logic so effects have complete dependency arrays.
export function useSearchableList(endpoint) {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");

  const reload = useCallback(() => {
    api
      .get(endpoint, { params: search ? { search } : {} })
      .then((r) => setItems(r.data))
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.warn(`Failed to load ${endpoint}`, err);
        }
      });
  }, [endpoint, search]);

  useEffect(() => {
    const timer = setTimeout(reload, search ? 300 : 0);
    return () => clearTimeout(timer);
  }, [reload, search]);

  // Refresh once offline edits have synced (temp ids become real ids)
  useSyncedReload(reload);

  return { items, search, setSearch, reload };
}
